const userDeviceType = () => {
  const {
    userAgent
  } = navigator;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
    return 'Tablet';
  }
  if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(userAgent)) {
    return 'Phone';
  }
  return 'Desktop';
};
export default userDeviceType;
//# sourceMappingURL=isOfType.js.map